import React from "react";
import { Snackbar, Alert, LinearProgress, AlertColor } from "@mui/material";

interface CustomSnackbarProps {
  open: boolean;
  message: string;
  severity?: AlertColor;
  progress: number;
  duration?: number;
  onClose: () => void;
}

const CustomSnackbar: React.FC<CustomSnackbarProps> = ({
  open,
  message,
  severity = "info",
  progress,
  duration = 6000,
  onClose,
}) => {
  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        sx={{ width: "100%", position: "relative", p: 2 }}
      >
        {message}
        <LinearProgress
          variant="determinate"
          value={progress}
          color={severity}
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: 4,
            borderBottomLeftRadius: 4,
            borderBottomRightRadius: 4,
          }}
        />
      </Alert>
    </Snackbar>
  );
};

export default CustomSnackbar;
